/** Pick-up orders carry a 3-character kitchen code; delivery orders keep the 8-char id. */

/** True when the order has a pick-up code (null, missing and '' all count as absent). */
export function hasPickupCode(o: { pickup_code?: string | null }): boolean {
  return !!o.pickup_code;
}

/** The label staff and fans use for an order: the pick-up code, else `#` + the first 8 id chars. */
export function orderCodeLabel(o: { id: string; pickup_code?: string | null }): string {
  return hasPickupCode(o) ? (o.pickup_code as string) : '#' + o.id.slice(0, 8).toUpperCase();
}
